import { render, staticRenderFns } from "./groupYearReport.vue?vue&type=template&id=20dd07c6&scoped=true&"
import script from "./groupYearReport.vue?vue&type=script&lang=js&"
export * from "./groupYearReport.vue?vue&type=script&lang=js&"
import style0 from "./groupYearReport.vue?vue&type=style&index=0&id=20dd07c6&scoped=true&lang=css&"
import style1 from "./groupYearReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd07c6",
  null
  
)

export default component.exports